import { IkasImage } from "../image";
import { IkasHTMLMetaData } from "../html-meta-data";
import { IkasBaseModel } from "../base";
import { IkasCategoryPathItem } from "./path-item";
import { IkasCategoryTranslation } from "./translations";

export type IkasCategory = {
  categoryPath: string[] | null;
  description: string | null;
  imageId: string | null;
  name: string;
  parentId: string | null;
  metaData: IkasHTMLMetaData | null;
  categoryPathItems: IkasCategoryPathItem[];
  orderType: IkasCategoryProductsOrderType | null;

  image?: IkasImage | null;
  translations?: IkasCategoryTranslation[] | null;
} & IkasBaseModel;

export enum IkasCategoryProductsOrderType {
  BEST_SELLER = "BEST_SELLER",
  HIGHEST_DISCOUNT_RATIO = "HIGHEST_DISCOUNT_RATIO",
  HIGHEST_PRICE = "HIGHEST_PRICE",
  LOWEST_DISCOUNT_RATIO = "LOWEST_DISCOUNT_RATIO",
  LOWEST_PRICE = "LOWEST_PRICE",
  MANUALLY = "MANUALLY",
  NEWEST = "NEWEST",
  OLDEST = "OLDEST",
}
